var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('main',{attrs:{"role":"main"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row mb-5"},[_c('div',{staticClass:"col-md-12"},[_c('h2',{staticClass:"mb-5"},[_c('font-awesome-icon',{attrs:{"icon":"home"}}),_vm._v("\n                        SubPage 2\n                    ")],1)])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bbc39b8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/SubPageTwo.vue
// module id = null
// module chunks = 